import { computed, ComputedRef, Ref, ref } from "vue";

export interface PendingChanges {
  pending: Ref<number>;
  loading: ComputedRef<boolean>;
  increment: () => number;
  decrement: () => number;
}

export const usePendingChanges = (): PendingChanges => {
  const pending = ref(0);
  const increment = () => (pending.value += 1);
  const decrement = () => (pending.value -= 1);
  const loading = computed(() => pending.value > 0);

  return {
    pending,
    loading,
    increment,
    decrement,
  };
};

export default usePendingChanges;
